import React from "react"
import { Dialog, FlatButton } from "material-ui"
import BiometricException from "./biometric/BiometricException"
import LocationException from "./location/LocationException"
import LeftArrow from "material-ui/svg-icons/hardware/keyboard-arrow-left"
import RightArrow from "material-ui/svg-icons/hardware/keyboard-arrow-right"
import { grey400 } from "material-ui/styles/colors"
import autobind from "class-autobind"
import strings from "../../../localization/strings"
import { EExceptionReviewDialogExceptionType, EExceptionReviewDialogReviewType, EExceptionType, IPunchDocument } from "../../../models"
interface IPunchExceptionData {
	punchId: string
	type: EExceptionReviewDialogExceptionType
}
interface IProps {
	punchId: string
	clickedExceptionType: EExceptionReviewDialogExceptionType
	punches: IPunchDocument[]
	reviewedType: EExceptionReviewDialogReviewType
	availableExceptionTypes: EExceptionReviewDialogExceptionType[]
	handleClose(): void
}
interface IState {
	punchId: string
	exceptionType: EExceptionReviewDialogExceptionType
	punchExceptions: IPunchExceptionData[]
	paperHeight: number
}

export default class ExceptionDialog extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props)
		this.state = {
			punchId: props.punchId,
			exceptionType: props.clickedExceptionType,
			punchExceptions: this.getPunchExceptions(props.punches),
			paperHeight: 500
		}
		autobind(this)
	}

	componentDidMount() {
		this.updateDimensions()
		window.addEventListener("resize", this.updateDimensions.bind(this))
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.updateDimensions)
	}

	updateDimensions() {
		this.setState({ paperHeight: window.innerHeight - 250 > 720 ? 720 : window.innerHeight - 250 })
	}

	getPunchExceptions(punches: IPunchDocument[]): IPunchExceptionData[] {
		const punchExceptions: IPunchExceptionData[] = []
		punches.forEach(punch => {
			if (punch.PunchExceptions && punch.PunchExceptions.constructor === Array) {
				if (this.props.availableExceptionTypes.includes(EExceptionReviewDialogExceptionType.Biometric)) {
					const biometricException = punch.PunchExceptions.some(i => {
						if (this.props.reviewedType === EExceptionReviewDialogReviewType.All) {
							return i.TypeEnum === EExceptionType.BIOMETRIC
						}
						else if (this.props.reviewedType === EExceptionReviewDialogReviewType.NotReviewed) {
							return i.TypeEnum === EExceptionType.BIOMETRIC && (i.RevisedScore === 0 || i.RevisedScore === -1) && !i.Reviewed
						}
						else if (this.props.reviewedType === EExceptionReviewDialogReviewType.Reviewed) {
							return i.TypeEnum === EExceptionType.BIOMETRIC && i.Reviewed && !i.Rejected
						}
						else if (this.props.reviewedType === EExceptionReviewDialogReviewType.Rejected) {
							return i.TypeEnum === EExceptionType.BIOMETRIC && i.Rejected
						}
						else {
							return false
						}
					})
					biometricException &&
						punchExceptions.push({
							punchId: punch.Id,
							type: EExceptionReviewDialogExceptionType.Biometric
						})
				}

				if (this.props.availableExceptionTypes.includes(EExceptionReviewDialogExceptionType.Location)) {
					const locationExceptions = [EExceptionType.LOCATION, EExceptionType.MICRO_LOCATION, EExceptionType.NO_LOCATION_OR_MICROLOCATION, EExceptionType.NO_DEVICE_LOCATION]
					const locationException = punch.PunchExceptions.some(i => {
						if (this.props.reviewedType === EExceptionReviewDialogReviewType.All) {
							return locationExceptions.includes(i.TypeEnum)
						}
						else if (this.props.reviewedType === EExceptionReviewDialogReviewType.NotReviewed) {
							return locationExceptions.includes(i.TypeEnum) && !i.Reviewed
						}
						else if (this.props.reviewedType === EExceptionReviewDialogReviewType.Reviewed) {
							return locationExceptions.includes(i.TypeEnum) && i.Reviewed
						}
						else if (this.props.reviewedType === EExceptionReviewDialogReviewType.Rejected) {
							return locationExceptions.includes(i.TypeEnum) && i.Rejected
						}
						else {
							return false
						}
					})
					locationException &&
						punchExceptions.push({
							punchId: punch.Id,
							type: EExceptionReviewDialogExceptionType.Location
						})
				}
			}
		})
		return punchExceptions
	}

	navigate(index) {
		const exception = this.state.punchExceptions[index]
		this.setState({ punchId: exception.punchId, exceptionType: exception.type })
	}

	render() {
		const indexNum = this.state.punchExceptions.findIndex(i => i.punchId === this.state.punchId && i.type === this.state.exceptionType)
		return (
			<Dialog
				modal
				open
				actions={<FlatButton data-intercom-target={`ExceptionDialog-${this.state.exceptionType}-${this.props.punchId}-Btn-CloseExceptionDialog`} label={strings.Close} primary onClick={this.props.handleClose} />}
				contentStyle={{ width: 1200, maxWidth: "none" }}
				onRequestClose={this.props.handleClose}
			>
				{this.state.exceptionType === EExceptionReviewDialogExceptionType.Biometric &&
					<BiometricException
						punchId={this.state.punchId}
						paperHeight={this.state.paperHeight}
					/>
				}
				{this.state.exceptionType === EExceptionReviewDialogExceptionType.Location &&
					<LocationException
						punchId={this.state.punchId}
						paperHeight={this.state.paperHeight}
					/>
				}
				{indexNum !== 0 &&
					<LeftArrow
						className="NextPrevExceptionArrow"
						data-intercom-target={`ExceptionDialog-${this.state.exceptionType}-${this.props.punchId}-Btn-PreviousException`}
						style={{ width: 60, height: this.state.paperHeight, left: 5, borderRadius: 20, cursor: "pointer", position: "absolute", top: 70, fill: grey400 }}
						onClick={() => this.navigate(indexNum - 1)}
					/>
				}
				{indexNum !== this.state.punchExceptions.length - 1 &&
					<RightArrow
						className="NextPrevExceptionArrow"
						data-intercom-target={`ExceptionDialog-${this.state.exceptionType}-${this.props.punchId}-Btn-NextException`}
						style={{ width: 60, height: this.state.paperHeight, right: 5, borderRadius: 20, cursor: "pointer", position: "absolute", top: 70, fill: grey400 }}
						onClick={() => this.navigate(indexNum + 1)}
					/>
				}
			</Dialog>
		)
	}
}
